<nav class="flex items-center justify-center md:justify-start gap-4 text-sm my-5 xl:mx-0">

    <button
        [disabled]="current === 1 || total <= 1"
        class="flex"
        [ngClass]="current === 1 || total <= 1 ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'"
        title="{{ 'paginator_prev' | translate }}"
        (click)="clickPrev($event)"
    >
        <svg class="fill-primary transform rotate-90 w-6 h-6 rounded-full border border-white hover:border-secondary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>
        </svg>
        {{ 'paginator_prev' | translate }}
    </button>

    <div>{{ current + ' / ' + total }}</div>

    <button
        [disabled]="current === total"
        class="flex"
        [ngClass]="current === total ? 'cursor-not-allowed opacity-75' : 'cursor-pointer'"
        title="{{ 'paginator_next' | translate }}"
        (click)="clickNext($event)"
    >
        {{ 'paginator_next' | translate }}
        <svg class="fill-primary transform -rotate-90 w-6 h-6 rounded-full border border-white hover:border-secondary" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
            <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"></path>
        </svg>
    </button>

</nav>
